module.exports = __webpack_public_path__ + "static/media/ic-linkedin.6b011cf9.svg";